export const lightClassColors = [
  '#CB4B51', '#FF8B48', '#FFCF71', '#F7A9E1', '#ECA3A1',
  '#E283B2', '#9A9CE3', '#8EBEF6', '#65C5FA', '#7ED691', '#53B38F'
];

const darkClassColors = [
  '#D42B33', '#F6772E', '#FFC24C', '#FF84DC', '#FF837F',
  '#E772AC', '#7F82E5', '#63AAFD', '#38B6FC', '#60DF7C', '#19BD7F'
];

export function getColor(lightColor, isDark) {
  if (!isDark) return lightColor;
  const idx = lightClassColors.indexOf(lightColor);
  return idx !== -1 ? darkClassColors[idx] : lightColor;
}

export const lightTheme = {
  // Primary (Key Color)
  primary: '#FF8B48',
  primaryHover: '#FF6C16',
  primaryAlpha5: 'rgba(255, 139, 72, 0.05)',
  primaryAlpha10: 'rgba(255, 139, 72, 0.1)',
  primaryAlpha20: 'rgba(255, 139, 72, 0.2)',
  primaryAlpha50: 'rgba(255, 139, 72, 0.5)',
  primaryGradient: 'linear-gradient(90deg, #FFA570 0%, #FF8B48 100%)',

  // Sub Key Color
  subKey: '#6DD49E',
  subKeyHover: '#2EAA69',
  subKeyAlpha50: 'rgba(109, 212, 158, 0.5)',

  // Point Colors
  pointYellow: '#FFB800',
  pointYellowHover: '#EEAB00',
  pointBlue: '#2F80ED',
  pointBlueHover: '#016BFB',
  pointRed: '#D92828',
  pointRedHover: '#FF0000',
  pointRedAlpha10: 'rgba(217, 40, 40, 0.1)',
  pointRedAlpha20: 'rgba(217, 40, 40, 0.2)',
  pointRedAlpha30: 'rgba(217, 40, 40, 0.3)',
  pointRedAlpha50: 'rgba(217, 40, 40, 0.5)',
  pointYellowAlpha30: 'rgba(255, 184, 0, 0.3)',

  // Gray
  gray: '#CBCBCB',

  // White
  white: '#FFFFFF',
  whiteAlpha20: 'rgba(255, 255, 255, 0.2)',

  // Text
  keyText: '#232323',
  text: '#232323',
  subText: '#777777',
  historyText: '#777777',

  // Button
  buttonFill: '#F5F6F8',
  buttonStroke: '#DFDFDF',
  buttonFill2: '#969696',
  buttonFill3: '#E2E2E2',

  // Line
  line: '#D4D4D4',

  // Scroll Bar
  scrollBar: '#CFCFCF',

  // Gym Naem (Multi login)
  gymName: '#FFFFFF',

  // Shadow
  shadow: '0px 4px 16px rgba(0, 0, 0, 0.06)',
  shadowLarge: '0px 8px 40px rgba(0, 0, 0, 0.10)',

  // Background
  background: '#FDFCFB',
  subBackground: '#FFFFFF',

  // Ai Chatting
  chatBoxBackground: `#FFFFFF`,

  // Bottom 
  bottomText: '#969696',

  // Logo
  logo1: '#D6D4D2',
  logo2: '#F2F2F1',
  logo3: '#B5B0AE',

  // Class Colors
  class1: '#CB4B51',
  class2: '#FF8B48',
  class3: '#FFCF71',
  class4: '#F7A9E1',
  class5: '#ECA3A1',
  class6: '#E283B2',
  class7: '#9A9CE3',
  class8: '#8EBEF6',
  class9: '#65C5FA',
  class10: '#7ED691',
  class11: '#53B38F',

  // Category Colors
  category1: '#6DD49E',
  category2: '#FF8B48',
  category3: '#FFB800',
  category4: '#D92828',
  category5: '#65C5FA',
};

export const darkTheme = {
  // Primary (Key Color)
  primary: '#FF8333',
  primaryHover: '#FF6C16',
  primaryAlpha5: 'rgba(255, 131, 51, 0.05)',
  primaryAlpha10: 'rgba(255, 122, 30, 0.1)',
  primaryAlpha20: 'rgba(255, 122, 30, 0.2)',
  primaryAlpha50: 'rgba(255, 122, 30, 0.5)',
  primaryGradient: 'linear-gradient(90deg, #C53F1E 0%, #FF8333 100%)',

  // Sub Key Color
  subKey: '#6DD49E',
  subKeyHover: '#2EAA69',
  subKeyAlpha: 'rgba(109, 212, 158, 0.5)',
  subKeyAlpha50: 'rgba(109, 212, 158, 0.5)',

  // Point Colors
  pointYellow: '#FFB800',
  pointYellowHover: '#EEAB00',
  pointBlue: '#2F80ED',
  pointBlueHover: '#016BFB',
  pointRed: '#D92828',
  pointRedHover: '#FF0000',
  pointRedAlpha10: 'rgba(217, 40, 40, 0.1)',
  pointRedAlpha20: 'rgba(217, 40, 40, 0.2)',
  pointRedAlpha30: 'rgba(217, 40, 40, 0.3)',
  pointRedAlpha50: 'rgba(217, 40, 40, 0.5)',
  pointYellowAlpha30: 'rgba(255, 184, 0, 0.3)',

  // Gray
  gray: '#CBCBCB',

  // White
  white: '#F1F1F1',
  whiteAlpha20: 'rgba(241, 241, 241, 0.2)',

  // Text
  keyText: '#FF8333',
  text: '#EFEFEF',
  subText: '#EFEFEF',
  historyText: '#FFFFFF',

  // Button
  buttonFill: '#1D1D1D',
  buttonStroke: '#1D1D1D',
  buttonFill2: '#FF8333',
  buttonFill3: '#282828',

  // Line
  line: '#636363',

  // Scroll Bar
  scrollBar: '#FF8333',

  // Gym Naem (Multi login)
  gymName: '#F1F1F1',
  
  // Shadow
  shadow: '0px 4px 16px rgba(0, 0, 0, 0.06)',
  shadowLarge: '0px 8px 40px rgba(0, 0, 0, 0.10)',

  // Background
  background: '#0F0F0F',
  subBackground: '#1B1B1B',

  // Ai Chatting
  chatBoxBackground: `#1B1B1B`,

  // Bottom Info
  bottomText: '#969696',

  // Logo
  logo1: '#1F1E1E',
  logo2: '#373737',
  logo3: '#1C1C1C',

  // Class Colors
  class1: '#D42B33',
  class2: '#FF8333',
  class3: '#FFCF71',
  class4: '#FF84DC',
  class5: '#FF837F',
  class6: '#E772AC',
  class7: '#7F82E5',
  class8: '#63AAFD',
  class9: '#38B6FC',
  class10: '#60DF7C',
  class11: '#19BD7F',

  // Category Colors
  category1: '#52B07F',
  category2: '#FF8333',
  category3: '#FFB800',
  category4: '#D92828',
  category5: '#38B6FC',
};
